import { Officer } from '../types/commission';

/** The signed-in user. */
export const currentOfficerId = 'marcus-ellery';

export const officers: Officer[] = [
  {
    id: 'marcus-ellery',
    name: 'Marcus Ellery',
    email: 'marcus.ellery@northbridgelending.com',
    roleId: 'senior-loan-officer',
    branch: 'Charlotte, NC · Branch 208',
    nmls: 'NMLS #1184920',
    initials: 'ME',
  },
  {
    id: 'priya-raman',
    name: 'Priya Raman',
    email: 'priya.raman@northbridgelending.com',
    roleId: 'loan-partner',
    branch: 'Charlotte, NC · Branch 208',
    nmls: 'NMLS #2209183',
    initials: 'PR',
  },
  {
    id: 'jared-kowalski',
    name: 'Jared Kowalski',
    email: 'jared.kowalski@northbridgelending.com',
    roleId: 'loan-officer',
    branch: 'Raleigh, NC · Branch 114',
    nmls: 'NMLS #1937744',
    initials: 'JK',
    monthlyUnits: { '2026-08': 3, '2026-07': 4, '2026-06': 3, '2026-05': 2 },
  },
  {
    id: 'owen-baptiste',
    name: 'Owen Baptiste',
    email: 'owen.baptiste@northbridgelending.com',
    roleId: 'loan-officer',
    branch: 'Raleigh, NC · Branch 114',
    nmls: 'NMLS #2041176',
    initials: 'OB',
    monthlyUnits: { '2026-08': 2, '2026-07': 4, '2026-06': 0, '2026-05': 3 },
  },
  {
    id: 'camille-fontaine',
    name: 'Camille Fontaine',
    email: 'camille.fontaine@northbridgelending.com',
    roleId: 'executive-loan-officer',
    branch: 'Charlotte, NC · Branch 208',
    nmls: 'NMLS #998812',
    initials: 'CF',
  },
  {
    id: 'talia-nakamura',
    name: 'Talia Nakamura',
    email: 'talia.nakamura@northbridgelending.com',
    roleId: 'developmental-team-lead',
    branch: 'Greenville, SC · Branch 311',
    nmls: 'NMLS #1650287',
    initials: 'TN',
  },
  {
    id: 'andre-sterling',
    name: 'Andre Sterling',
    email: 'andre.sterling@northbridgelending.com',
    roleId: 'senior-team-lead',
    branch: 'Charlotte, NC · Branch 208',
    nmls: 'NMLS #1320945',
    initials: 'AS',
  },
  {
    id: 'monica-alvarado',
    name: 'Monica Alvarado',
    email: 'monica.alvarado@northbridgelending.com',
    roleId: 'division-lead',
    branch: 'Carolinas Division',
    nmls: 'NMLS #874310',
    initials: 'MA',
  },
  {
    id: 'hannah-brooks',
    name: 'Hannah Brooks',
    email: 'hannah.brooks@northbridgelending.com',
    roleId: 'loan-processor',
    branch: 'Operations · Charlotte',
    nmls: 'Processing',
    initials: 'HB',
  },
  {
    id: 'luis-delgado',
    name: 'Luis Delgado',
    email: 'luis.delgado@northbridgelending.com',
    roleId: 'senior-loan-processor',
    branch: 'Operations · Charlotte',
    nmls: 'Processing',
    initials: 'LD',
  },
  {
    id: 'sofia-reyes',
    name: 'Sofia Reyes',
    email: 'sofia.reyes@northbridgelending.com',
    roleId: 'processing-admin',
    branch: 'Operations · Raleigh',
    nmls: 'Processing',
    initials: 'SR',
  },
  {
    id: 'victor-duarte',
    name: 'Victor Duarte',
    email: 'victor.duarte@northbridgelending.com',
    roleId: 'loan-execution-manager',
    branch: 'Operations · Company',
    nmls: 'Loan Execution',
    initials: 'VD',
  },
  {
    id: 'grace-okafor',
    name: 'Grace Okafor',
    email: 'grace.okafor@northbridgelending.com',
    roleId: 'avp-processing',
    branch: 'Operations · Company',
    nmls: 'Processing Leadership',
    initials: 'GO',
  },
];
